module.exports = __webpack_public_path__ + "static/media/tabletennis-icon.13cc1f52.webp";